import {
  AlertTriangle,
  Castle,
  Flag,
  Gem,
  MapPin,
  Mountain,
  Navigation,
  Skull,
  Star,
} from 'lucide-react';

export const PIN_TYPES = [
  { id: 'city', label: { fr: 'Ville', en: 'City' }, icon: Castle, color: '#3B82F6' },
  { id: 'dungeon', label: { fr: 'Donjon', en: 'Dungeon' }, icon: Mountain, color: '#6B7280' },
  { id: 'quest', label: { fr: 'Quête', en: 'Quest' }, icon: Star, color: '#F59E0B' },
  { id: 'danger', label: { fr: 'Danger', en: 'Danger' }, icon: Skull, color: '#EF4444' },
  { id: 'treasure', label: { fr: 'Trésor', en: 'Treasure' }, icon: Gem, color: '#10B981' },
  { id: 'faction', label: { fr: 'Faction', en: 'Faction' }, icon: Flag, color: '#8B5CF6' },
  { id: 'event', label: { fr: 'Événement', en: 'Event' }, icon: AlertTriangle, color: '#EC4899' },
  { id: 'portal', label: { fr: 'Portail', en: 'Portal' }, icon: Navigation, color: '#06B6D4' },
  { id: 'custom', label: { fr: 'Autre', en: 'Other' }, icon: MapPin, color: '#6366F1' },
];

export const getPinIcon = (pinType) => PIN_TYPES.find((item) => item.id === pinType)?.icon || MapPin;

export const getPinColor = (pinType) => PIN_TYPES.find((item) => item.id === pinType)?.color || '#6366F1';

export const getPinLabel = (pinType, language) => (
  PIN_TYPES.find((item) => item.id === pinType)?.label?.[language] || pinType
);

export const resolvePinColor = (pin) => (
  /^#[0-9a-f]{6}$/i.test(pin?.color || '') ? pin.color : getPinColor(pin?.pin_type)
);

export const pinToMapPoint = (pin, width, height) => ({
  x: Math.max(0, Math.min(1, Number(pin?.x) || 0)) * width,
  y: Math.max(0, Math.min(1, Number(pin?.y) || 0)) * height,
});
